import { render, staticRenderFns } from "./ZztShenchaList.vue?vue&type=template&id=6033eeb7&scoped=true&"
import script from "./ZztShenchaList.vue?vue&type=script&lang=js&"
export * from "./ZztShenchaList.vue?vue&type=script&lang=js&"
import style0 from "./ZztShenchaList.vue?vue&type=style&index=0&id=6033eeb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033eeb7",
  null
  
)

export default component.exports